import { queryEvents } from '@wix/ambassador-events-v3-event/http';
import { RequestedFields } from '@wix/ambassador-events-v3-event/types';
import { isNotOptional } from '@wix/seo-common-core';
import { chunk } from 'lodash';
const PAGE_LIMIT = 100;
export const fetchEvents = async (httpClient, errorHandler, t, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  const idChunks = chunk(ids, PAGE_LIMIT);
  const processChunk = async idChunk => {
    const chunkEvents = [];
    await withErrorHandler(async () => {
      let hasMore = true;
      let offset = 0;
      do {
        const {
          data: {
            events,
            pagingMetadata
          }
        } = await httpClient.request(queryEvents({
          fields: [RequestedFields.DETAILS, RequestedFields.TEXTS],
          query: {
            filter: idChunk.length > 0 ? {
              id: {
                $in: idChunk
              }
            } : undefined,
            paging: {
              limit: PAGE_LIMIT,
              offset
            }
          }
        }));
        chunkEvents.push(...(events ?? []));
        if (isNotOptional(pagingMetadata == null ? void 0 : pagingMetadata.total) && isNotOptional(pagingMetadata == null ? void 0 : pagingMetadata.offset) && isNotOptional(pagingMetadata == null ? void 0 : pagingMetadata.count)) {
          hasMore = pagingMetadata.total > pagingMetadata.offset + pagingMetadata.count;
        } else {
          hasMore = false;
        }
        offset += PAGE_LIMIT;
      } while (hasMore);
    }, {
      // todo: fix the default error message
      errorCodesMap: {
        applicationError: {
          FILTER_PARSER_ERROR: () => ({
            message: t('accessibility-wizard.save-error-modal.content')
          })
        }
      }
    });
    return chunkEvents;
  };
  const allEvents = async () => {
    const chunkPromises = idChunks.map(idChunk => processChunk(idChunk));
    const chunkResults = await Promise.all(chunkPromises);
    return chunkResults.flat();
  };
  return allEvents();
};
//# sourceMappingURL=fetch-events.js.map